import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course04 from "../../../course/course-04/course";
import lesson0404 from "../../../lesson/course-04/lesson-04/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "7febf03f-5dc7-438b-8274-cecf54dc9b85",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
];

export default lessonLinks;
